import {_utils} from "../../../utils/_utils.js";

export const completedJobs = () => {
    return new Promise((resolve) => {
        _utils.initSection('.completed-jobs', (section) => init(section));
        resolve();
    })
}

const init = (section) => {
    const tabs = [...section.querySelectorAll('[data-cj-tab]')];
    const compares = [...section.querySelectorAll('[data-cj-compare]')];
    const cards = [...section.querySelectorAll('[data-cj-card]')];

    if (!tabs.length) return;

    let activeIndex = null;

    const open = (index) => {
        activeIndex = index;
        section.classList.add('is-open');
        tabs.forEach((t) => t.classList.toggle('is-active', Number(t.dataset.cjTab) === index));
        compares.forEach((c) => c.classList.toggle('is-active', Number(c.dataset.cjCompare) === index));
    };

    const close = () => {
        activeIndex = null;
        section.classList.remove('is-open');
        tabs.forEach((t) => t.classList.remove('is-active'));
        compares.forEach((c) => c.classList.remove('is-active'));
    };

    tabs.forEach((tab) => {
        tab.addEventListener('click', () => {
            const index = Number(tab.dataset.cjTab);
            if (activeIndex === index) {
                close();
            } else {
                open(index);
            }
        });
    });

    // Clicking a fan card opens its comparison (and highlights the matching tab).
    cards.forEach((card) => {
        card.addEventListener('click', () => open(Number(card.dataset.cjCard)));
    });

    // Close the opened card when clicking outside it (but not on a tab, card, or the viewer).
    document.addEventListener('click', (e) => {
        if (activeIndex === null) return;
        if (e.target.closest('[data-cj-tab]') || e.target.closest('[data-cj-compare]') || e.target.closest('[data-cj-card]')) return;
        close();
    });

    compares.forEach(initCompare);
}

// Before/after drag comparison driven by the --pos CSS variable (0%..100%).
const initCompare = (compare) => {
    const drag = compare.querySelector('[data-cj-drag]');

    const setPos = (clientX) => {
        const rect = compare.getBoundingClientRect();
        let pct = ((clientX - rect.left) / rect.width) * 100;
        pct = Math.max(0, Math.min(100, pct));
        compare.style.setProperty('--pos', pct + '%');
    };

    // "Drag" cursor label follows the pointer inside the viewer (mouse only — CSS gates it).
    const moveDrag = (e) => {
        if (!drag) return;
        const rect = compare.getBoundingClientRect();
        drag.style.setProperty('--dx', (e.clientX - rect.left) + 'px');
        drag.style.setProperty('--dy', (e.clientY - rect.top) + 'px');
    };
    compare.addEventListener('pointerenter', () => compare.classList.add('is-hover'));
    compare.addEventListener('pointerleave', () => compare.classList.remove('is-hover'));
    compare.addEventListener('pointermove', moveDrag);

    compare.addEventListener('pointerdown', (e) => {
        compare.setPointerCapture(e.pointerId);
        compare.classList.add('is-dragging');
        setPos(e.clientX);
    });

    compare.addEventListener('pointermove', (e) => {
        if (!compare.hasPointerCapture(e.pointerId)) return;
        setPos(e.clientX);
    });

    const release = (e) => {
        if (compare.hasPointerCapture(e.pointerId)) {
            compare.releasePointerCapture(e.pointerId);
        }
        compare.classList.remove('is-dragging');
    };
    compare.addEventListener('pointerup', release);
    compare.addEventListener('pointercancel', release);
}
